const setFeatureToggles = require('../services/featureToggles')

const hostedZoneId = 'Z09409813QZHFYXOVWMAX'
const domainName = 'ssr.cscshopfront.com'
const environmentName = 'production'

const CDN_PREFIX = `https://${domainName}`

const Layer0DnsRecordName = 'uat.onekingslane.com	'
const Layer0DnsRecordType = 'A'
const Layer0DnsRecordValue = [
  '208.69.180.11',
  '208.69.180.12',
  '208.69.180.13',
  '208.69.180.14',
].join(',')
const Layer0DnsSslChallengeName = '_acme-challenge.uat.onekingslane.com'
const Layer0DnsSslChallengeValue = '_acme-challenge.xdn-validation.com'
const BigCommerceDnsSslChallengeName = '_171DE01A775451186B9D4D6718CF3A98.uat.onekingslane.com'
const BigCommerceDnsSslChallengeValue = '4A7E5161F014FF21D62A0D748F8EAECF.C22EEC10EB1BFA1BA02C4877C5B1FAAB.626b10d42da89.comodoca.com'
const MerchantHostedZoneId = 'Z03800471ZSBSJFE7HPGZ'

module.exports = {
  ENABLE_CITIZENS: 'true',
  CITIZENS_SCRIPT: 'https://toolbox.jifiti.com/Widgets/1.0.3/jifiti-widget.min.js',
  CITIZENS_WIDGET_KEY: '38ac1147c33545ec8c5a4aa9a2951d72',
  AWS_REGION: 'us-east-1',
  AWS_PROFILE: 'zgallerie',
  CHECKOUT_DOMAIN: '/checkout-frame',
  CHECKOUT_IDENTIFIER: 'okl-production',
  DOMAIN_NAME: domainName,
  ENVIRONMENT_NAME: environmentName,
  CONFIG_FILE: 'production.json',
  RECREATE_URL: null,
  CONTENT_PREVIEW: false,
  CONTENT_API: 'https://diuhh8z0rj.execute-api.us-east-1.amazonaws.com/Prod/v1', //diuhh8z0rj.execute-api.us-east-1.amazonaws.com
  SEARCH_API: 'https://gfkldh9057.execute-api.us-east-1.amazonaws.com/Prod',
  SHOP_ORIGIN: 'https://www.onekingslane.com',
  CDN_PREFIX,
  BC_APP_CLIENT_ID: 'o6yd0dlvs1whutshu0ioeekoy92eag6', // TODO: replace with production api key
  SHOP_HASH: 'xx4tpvew0y',
  GA_TRACKING_ID: 'GTM-WB5VZMG',
  FACEBOOK_PIXEL_ID: '283982441787275',
  DeployParameterOverrides: JSON.stringify({
    HostedZoneId: hostedZoneId,
    DomainName: domainName,
    EnvironmentName: environmentName,
    Layer0DnsRecordName,
    Layer0DnsRecordType,
    Layer0DnsRecordValue,
    Layer0DnsSslChallengeName,
    Layer0DnsSslChallengeValue,
    BigCommerceDnsSslChallengeName,
    BigCommerceDnsSslChallengeValue,
    MerchantHostedZoneId,
  }),
  BOPUS_FIELD: 'field_30',
  BOPUS_STORE_FIELD: 'field_32',
  DTP_NUMBER_FIELD: 'field_36',
  CHECKOUT_VERSION_FIELD: 'field_38',
  STORE_CREDITS_APPLIED_FIELD: 'field_42',
  FEATURE_TOGGLES: setFeatureToggles(environmentName),
  CRITEO_ACCOUNT_ID: '12345',
  VITALS_LOGGING_API: 'https://3diyhy88wk.execute-api.us-east-1.amazonaws.com/Prod',
  CHECKOUT_EXPERIMENT_ID: 'YxeHn4CZQcuVyY2CNIvZGw',
  PLACES_KEY: 'AIzaSyByVdDl6_bObUos3uqDH3xpt-eAHV0yBqg',
  HOTJAR_ID: '1548946',
  LISTRAK_ID: 'T6phidacCJdz',
  WUNDERKIND_ID: '3212',
  CONTENTFUL_ACCESS_TOKEN: 'I5HYKTK43eGEHm1qpyzESUuZLgIw4R151hDzAcdvQT8',
  CONTENTFUL_SPACE_ID: 'p62egiw5uahp',
  CONTENTFUL_ENVIRONMENT: 'master',
  EXTEND_ID: '56c1e431-8bb0-4e91-951e-ecd0a936dac7',
  EXTEND_ENVIRONMENT: 'production',
  CITIZENS_PAY_EXPERIMENT_ID: 'HvQ_ItYNSBKLqRKpIgOM5w',
  SHOP_TOKEN_SCRIPT: 'https://web-js.bigshoptoken.com/main.js',
  SENTRY_DSN: 'https://636b9931b0164c9f99f8d182cb8badaa@o32694.ingest.sentry.io/6611343',
  SENTRY_ENVIRONMENT: 'production',
  OAuthClientId: 'q8vrvfxlc60hinovcz4olteq32g90dp',
  GraphQLStoreFrontJWT: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjaWQiOjEsImNvcnMiOlsiaHR0cHM6Ly93d3cub25la2luZ3NsYW5lLmNvbSIsImh0dHBzOi8vb25la2luZ3NsYW5lLmNvbSJdLCJlYXQiOjIxNDc0MDM1OTksImlhdCI6MTY1ODQyMDI5NSwiaXNzIjoiQkMiLCJzaWQiOjEwMDE2MjE0NTYsInN1YiI6ImlydXZrbXFjN2l2aTJqdWR2YTQ1cTJ4OWlyemVsZjMiLCJzdWJfdHlwZSI6MiwidG9rZW5fdHlwZSI6MX0.SNXgwXi6gVumsGK14_tHbjySlLavj8tQ51EqH5lEuoEANimZIxbm0QaXmNsVCaYd_L_lZ20BMDUYNd8By6V4lA', // Expires at 2147403599 allowed "https://www.onekingslane.com", "https://onekingslane.com"
  OAUTH_API: '/oauth',
  ReadonlyBigCAccessToken: 'qq899o7ctmaskpbpbbskrco15mtunik',
  CSC_SHOPFRONT_API: 'api.cscshopfront.com',
  CSC_PAYMENTS_HOST: 'api.cscpaymentsservices.com',
  CSC_PAYMENTS_GATEWAY: 'okl-production-cybersource',
  CSC_PAYMENTS_SHOP: 'okl-production',
  CSC_IAM_AUD: 'qd5ppux5x24qdqxskhk1ecjy0oyvxk8', // UPDATE THIS
  CSC_IAM_REGISTERED_IDP: 'okl-production-registered',
  CSC_IAM_GUEST_IDP: 'okl-production-guests', // double check these too
  CSC_IAM_ACCOUNT: '000000888888',
  CSC_IAM_REGISTERED_ROLE: 'SignedInProductionOklShopFrontCustomer',
  CSC_IAM_GUEST_ROLE: 'GuestProductionOklShopFrontCustomer',
  FINGERPRINT_ORG_ID: 'onekingslane_w20p',
  FINGERPRINT_MERCHANT_ID: 'opco_master_acct'
}
